import { isRichContent } from '@wix/ricos';
import { extractMediaUrls } from './extract-media-urls';

export const extractMediaUrlsFromRichContent = (
  content: Record<string, any>,
): string[] | undefined => {
  if (isRichContent(content)) {
    return extractMediaUrls(content.nodes);
  }
};
